import { menuColorThemes, defaultMenuColorTheme, getMenuColorTheme } from '~/utils/menuColorThemes'

function useMenuColorThemeKey() {
  return useState<string>('menuColorThemeKey', () => {
    if (typeof localStorage === 'undefined') return defaultMenuColorTheme

    return localStorage.getItem('iqa-menu-color-theme') || defaultMenuColorTheme
  })
}

// Bindear esto como :key de <NuxtPage> fuerza a Vue a desmontar y volver a montar
// la pagina actual (y con ella cualquier Tabulator que contenga) sin recargar el
// navegador, ya que Tabulator no se adapta bien a cambios de estilo en caliente.
export function usePageRemountKey() {
  return useState<number>('pageRemountKey', () => 0)
}

export function useMenuColorTheme() {
  const themeKey = useMenuColorThemeKey()
  const theme = computed(() => getMenuColorTheme(themeKey.value))

  function setMenuColorTheme(key: string) {
    themeKey.value = key
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('iqa-menu-color-theme', key)
    }
    if (getMenuColorTheme(key).reloadOnSelect) {
      usePageRemountKey().value++
    }
  }

  return { themeKey, theme, setMenuColorTheme, themes: menuColorThemes }
}
